import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=493b66ca&"
import script from "./AccountPage.vue?vue&type=script&lang=ts&"
export * from "./AccountPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports